import Icon from 'ui/components/Icon'
import { Row, DragHandle, RowContent } from './styled'

export default function ChecklistRowGhost({ children }) {
  return (
    <Row data-row data-dragging="true" style={{ cursor: 'grabbing' }}>
      <DragHandle as="div" aria-hidden style={{ pointerEvents: 'none' }}>
        <Icon name="drag" size={16} />
      </DragHandle>

      <RowContent>{children}</RowContent>
    </Row>
  )
}
